export const DE: Record<string, string> = {
  Home: "Startseite",
  "Resource Selected": "Ausgewählte Ressource",
  "Resources List": "Ressourcenliste",
  List: "Liste",
  Resources: "Ressourcen",
  "Find Colleague": "Kollegen finden",
  Settings: "Einstellungen",
  "Floor Plan": "Grundriss",
  Locations: "Standorte",
  Categories: "Kategorien",
  "Search resource name...": "Ressourcennamen suchen...",
  Calendar: "Kalender",
  "View Details": "Details anzeigen",
  "Add to My Favorites": "Zu meinen Favoriten hinzufügen",
  Remove: "Entfernen",
  "Resource calendar": "Ressourcenkalender",
  Today: "Heute",
  "Previous month": "Vorheriger Monat",
  "Next month": "Nächster Monat",
  "Previous year": "Vorjahr",
  "Next year": "Nächstes Jahr",
  Close: "Schließen",
  "Field is required.": "Feld ist erforderlich.",
  "Invalid date format.": "Ungültiges Datumsformat.",
  S: "So",
  M: "Mo",
  T: "Di",
  W: "Mi",
  F: "Fr",
  January: "Januar",
  February: "Februar",
  March: "März",
  April: "April",
  May: "Mai",
  June: "Juni",
  July: "Juli",
  August: "August",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "Dezember",
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mär",
  Apr: "Apr",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Aug",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dez",
  st: "",
  nd: "",
  rd: "",
  th: "",
  Sunday: "Sonntag",
  Monday: "Montag",
  Tuesday: "Dienstag",
  Wednesday: "Mittwoch",
  Thursday: "Donnerstag",
  Friday: "Freitag",
  Saturday: "Samstag",
  Sun: "So",
  Mon: "Mo",
  Tue: "Di",
  Wed: "Mi",
  Thu: "Do",
  Fri: "Fr",
  Sat: "Sa",
  Su: "So",
  Mo: "Mo",
  Tu: "Di",
  We: "Mi",
  Th: "Do",
  Fr: "Fr",
  Sa: "Sa",
  PM: "nachm.",
  AM: "vorm.",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "Sie können diese Ressource nicht buchen, da Ihr Besprechungsanfrage im Widerspruch zu den Buchungsrichtlinien der Ressource steht.",
  "You need permissions to interact with this resource.":
    "Sie benötigen Berechtigungen, um mit dieser Ressource interagieren zu können.",
  Reason: "Grund",
  "The resource cannot be booked {{day}} days in advanced.":
    "Die Ressource kann nicht {{day}} Tage im Voraus gebucht werden.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "Das Enddatum einer wiederkehrenden Besprechung darf nicht mehr als {{day}} Tage ab heute liegen.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "Die Besprechungsdauer darf nicht länger als {{time}} Minuten sein.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "Die Besprechungsdauer darf nicht kürzer als {{time}} Minuten sein.",
  "Booking policy": "Buchungsrichtlinie",
  Available: "Verfügbar",
  Selected: "Ausgewählt",
  Booked: "Gebucht",
  Closed: "Geschlossen",
  "Filter Options": "Filteroptionen",
  "{{resource}} is deleted": "{{resource}} wurde gelöscht.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Diese Ressource kann gebucht werden, aber Vorkommen mit Konflikten werden nicht gebucht.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Diese Ressource kann im Voraus für maximal {{day}} Tage gebucht werden, alle Vorkommen über diese Grenze werden nicht gebucht",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Diese Ressource kann gebucht werden, aber die Besprechungsdauer muss mindestens {{time}} Minuten betragen.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Diese Ressource kann gebucht werden, aber die Besprechungsdauer darf {{time}} Minuten nicht überschreiten.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Die Buchung dieser Ressource erfordert die Genehmigung durch den Delegierten der Ressource. Ihre Anfrage wird zur Genehmigung weitergeleitet.",
  "Resource Name": "Ressourcenname",
  Description: "Beschreibung",
  "Resource Mail": "Ressourcen-E-Mail",
  Location: "Standort",
  Capacity: "Kapazität",
  Language: "Sprache",
  "Select an language": "Sprache auswählen",
  "Date/Time Format": "Datum-/Zeitformat",
  "First day of the week": "Erster Tag der Woche",
  "Please select a first day": "Bitte wählen Sie einen ersten Tag aus",
  "Please select a time format": "Bitte wählen Sie ein Zeitformat aus",
  "Date Format": "Datumsformat",
  "Please select a date format": "Bitte wählen Sie ein Datumsformat aus",
  "Date Separator": "Datums-Trennzeichen",
  "Please select a date separator":
    "Bitte wählen Sie ein Datums-Trennzeichen aus",
  Apply: "Anwenden",
  "Default Location": "Standardstandort",
  Clear: "Löschen",
  Help: "Hilfe",
  "Unavailable": "Nicht verfügbar",
      "No data available": "Keine Daten verfügbar",
      "More": "Mehr",
  "Available Floor Plans": "Verfügbare Grundrisse",
  "Default Categories": "Standardkategorien",
  "List more Resources": "Weitere Ressourcen auflisten",
  Attendees: "Teilnehmer",
  "Click on Further information to visit our support site":
    "Klicken Sie auf Weitere Informationen, um unsere Support-Site zu besuchen",
    "New Order": "Neue Bestellung",
    "Save default categories successfully": "Standardkategorien erfolgreich gespeichert",
      "Save config date/time successfully": "Konfigurationsdatum/-zeit erfolgreich gespeichert",
      "Save language successfully": "Sprache erfolgreich gespeichert",
      "Save default location successfully": "Standardstandort erfolgreich gespeichert",
      "And": "Und",
  "Or": "Oder",
  "Available occurrences of the series": "Verfügbare Vorkommen der Serie",
  "Conflicting Occurrences": "Widersprüchliche Vorkommen",
  "Availability": "Verfügbarkeit",
  "Time Format": "Zeitformat",
  "You do not have permission to book this resource.": "Sie haben keine Berechtigung, diese Ressource zu buchen.",
"This resource does not allow booking of recurring meetings.": "Diese Ressource erlaubt keine Buchung von wiederkehrenden Besprechungen.",
"You cannot book this resource.": "Sie können diese Ressource nicht buchen."
};
